export interface ReferenceUpdateDatabaseRequest {
  ids: number[]
}

export function ReferenceUpdateDatabaseRequestFromJSON(
  json: any
): ReferenceUpdateDatabaseRequest {
  return ReferenceUpdateDatabaseRequestFromJSONTyped(json)
}

export function ReferenceUpdateDatabaseRequestFromJSONTyped(
  json: any
): ReferenceUpdateDatabaseRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    ids: json.ids
  }
}

export function ReferenceUpdateDatabaseRequestToJSON(
  value: ReferenceUpdateDatabaseRequest
): any {
  return {
    ids: value.ids
  }
}
